export default {
  dbi_benchmark_mobile_game_benchmark: 'Mobile Game GaaS Analysis',
  dbi_benchmark_game_gacha:'Gacha',
  dbi_benchmark_game_casual: 'Casual',
  dbi_benchmark_game_shooter: 'Shooter',
  dbi_benchmark_game_sports: 'Sports',
  dbi_benchmark_game_slg: 'SLG',
  dbi_benchmark_game_mmo: 'MMO',
  dbi_benchmark_game_top: 'TOPs',
  dbi_benchmark_tops_info: 'The list is a selection of games that have performed well over the last five years. Feel free to contact @zhaofengliu, if you have any feedback or question of this list.',
  dbi_benchmark_trends_kpi_data: 'Trends of KPI Data',
  dbi_benchmark_regional_distribution_revenue: 'Regional Distribution of Revenue',
  dbi_benchmark_avg_dau: 'avg.DAU',
  dbi_benchmark_kpi_data: 'KPI data',
  dbi_benchmark_ral: 'Retention,ARPDAU,LTV',
  dbi_benchmark_retention_curve: 'Retention Curve',
  dbi_benchmark_earliest_date_mobile: 'Earliest date',

  dbi_benchmark_original: 'Original',
  dbi_benchmark_aligned_across_apps: 'Aligned across apps',
  dbi_benchmark_reorder_base: 'Re-order based on algorithms',
  dbi_benchmark_m1_m12: 'M1～M12',
  dbi_benchmark_y1_y5: 'Y1～Y5',
  dbi_benchmark_system: 'System',
  dbi_benchmark_both: 'Both',
  dbi_benchmark_ios: 'App Store',
  dbi_benchmark_android: 'Google Play',
  dbi_benchmark_ratios_by_region: 'Key Ratios by Region',
  dbi_benchmark_time_period: 'Time period',
  dbi_benchmark_summary_kpi_data: 'Summary of KPI Data',
  dbi_benchmark_system_demographics: 'System & Demographics',
  dbi_benchmark_game_level: 'Game Level',
  dbi_benchmark_overall: 'Overall',
  dbi_benchmark_device: 'Device',
  dbi_benchmark_stream_source: 'Stream source',
  dbi_benchmark_time_scale: 'Time scale',
  dbi_benchmark_twitch: 'Twitch',
  dbi_benchmark_youtube: 'Youtube',
  dbi_benchmark_facebook: 'Facebook',
  dbi_benchmark_lifetime: 'Lifetime',
  dbi_benchmark_365d: 'Latest 365 days',
  dbi_benchmark_30d: 'Latest 30 days',
  dbi_benchmark_revenue_trend: 'Revenue($)',
  dbi_benchmark_download_trend: 'Downloads',
  dbi_benchmark_dau_trend: 'avg.DAU',
  dbi_benchmark_revenue_mobile: 'Revenue',
  dbi_benchmark_download_mobile: 'Downloads',
  dbi_benchmark_dau_mobile: 'avg.DAU',
  dbi_benchmark_revenue_mobile_lower: 'revenue',
  dbi_benchmark_download_mobile_lower: 'download',
  dbi_benchmark_dau_mobile_lower: 'daily active users',
  dbi_benchmark_revenue_mobile_calc: 'Per Year = Sum of Revenue / Number of Games',
  dbi_benchmark_download_mobile_calc: 'Per Year = Sum of Downloads / Number of Games',
  dbi_benchmark_dau_mobile_calc: 'Per Year = Sum of all average DAU for all games / Number of Games',
  dbi_benchmark_ltv_365: 'LTV365',
  dbi_benchmark_relative: 'Relative CPI',
  dbi_benchmark_register: 'Register%',
  dbi_benchmark_avg_appStore_rating: 'Avg AppStore rating',
  dbi_benchmark_avg_googleplay_rating: 'Avg GooglePlay Rating',
  dbi_benchmark_db_earliest_date: 'DB Earliest Date',
  dbi_benchmark_db_release_date: 'DB Release Date',
  'dbi_benchmark_1y~5y_info': 'five years',
  'dbi_benchmark_1m~12m_info': 'twelve month',
  dbi_benchmark_reorder_base_info: `Considering the different trends of KPI data for various games, data scientists have recalibrated the game's API data over time using an algorithm to make the trend display more significant. The algorithm uses revenue as a reference, dynamically identifying the initial 12 months with the most significant revenue as Y1 after reordering. The values from Y2 to Y5 are then relatively calculated to Y1.`,
  dbi_benchmark_trends_kpi_data_info: `Here shows the average trends of KPI data over {type} since release date. Detailed game data can be found in 'Stats: KPI data' at the top of the page.`,
  dbi_benchmark_regional_distribution: 'Regional Distribution of {type}',
  dbi_benchmark_mobile_tyf_info: 'Provides data such as CCV, airtime and watch hours for each game on the respective streaming platforms.',
  dbi_benchmark_regional_distribution_revenue_info: 'Average {type} in each region:',
  dbi_benchmark_regional_distribution_revenue_calc: `Each region's share of the total average revenue`,
  dbi_benchmark_regional_distribution_download_calc: `Each region's share of the total average download count`,
  dbi_benchmark_regional_distribution_dau_calc: `Each region's share of the average of all games average DAU`,
  dbi_benchmark_system_demographics_info: `Here shows the average system distribution weighted by downloads. The user profile shown here is the gender breakdown and age breakdown of the selected genre, and if 'TOPs' or 'Customised' is selected, it will show the averaged breakdown.`,
  dbi_benchmark_ratios_by_region_info: `Here shows key ratios such as LTV365, relative CPI, and register% in each region. LTV365 is calculated based on the retention and ARPDAU data of each game in 'GaaS Capability', while the relative CPI and registration rate are calibrated based on some real data.`,
  dbi_benchmark_no_data_yet: 'No data yet',
  dbi_benchmark_retention: 'Retention',
  dbi_benchmark_system_device: 'Device',
  dbi_benchmark_system_device_up: 'DEVICE',
  dbi_benchmark_bar_trend_info: 'Average {type} for all games:',
  dbi_benchmark_mobile_average_days: 'Average day',
  dbi_benchmark_mobile_arpudau_curve: 'GaaS Capability: ARPDAU & Retention',
  dbi_benchmark_mobile_arpdau: 'ARPDAU',
  dbi_benchmark_total: 'Total',
  dbi_benchmark_source_info: 'Data of ${type} comes from',
  dbi_benchmark_databrain: 'Databrain',
  dbi_benchmark_table_revenue_lower: 'revenue',
  dbi_benchmark_table_download_lower: 'downloads',
  dbi_benchmark_table_dau_lower: 'avg.DAU',
  dbi_benchmark_google_app_info: 'Provide user ratings for each game in the shop',
  dbi_benchmark_retention_curve_mobile_info: 'Here shows the average retention of games at each level (S/A/B/C) under the selected genre, respectively',
  dbi_benchmark_retention_curve_mobile_info_6: 'Here shows the retention for each of the selected games.',
  dbi_benchmark_mobile_gass_capability_info_x: 'x-axis: Average play days of 1st year after release',
  dbi_benchmark_mobile_gass_capability_info_y: 'y-axis: Average ARPDAU of 1st year after release',
  dbi_benchmark_average_play_days: 'Average play days of 1st year after release',
  dbi_benchmark_mobile_data_ai_info: 'Provide KPI metrics of mobile games globally, such as Revenue, Downloads, Active Users. etc.',
  dbi_benchmark_introduce_mobile: 'The metrics are summarized based on data.ai. Feel free to contact @zhaofengliu for further information.',
  dbi_benchmark_tier: '{tier} Tier',
}